import { renderCellGrayZeros } from 'app/common/templates-next/table-template'
import { CellDataType } from 'app/common/templates-next/table-template/types'
import { isValueZero } from 'app/common/templates-next/table-template/isValueZero'

import { Entity } from './types'
import styles from './render-table-cell.module.scss'

export const renderTableCell = (cellData?: CellDataType<Entity>) => {
  if (cellData && Array.isArray(cellData.value)) {
    return (
      <div className={styles.column}>
        {cellData.value.map((item, index) => (
          <span
            key={`${cellData.columnKey}-${item}-${index}`}
            className={isValueZero(item) ? styles.zero : undefined}
          >
            {item}
          </span>
        ))}
      </div>
    )
  }

  return renderCellGrayZeros(cellData)
}
